import classNames from "classnames";
import React from "react";
import { Icon } from "rhombus-react";
import { BasicAction } from "widgets/ActionMenu";

export default function ImposiumAction(props) {
	const { url, tooltipContent, isDisabled, iconOnly } = props;
	const className = classNames(
		"action-link",
		"cypress-imposium-open-in-imposium-action",
		{ "is-disabled": isDisabled }
	);

	if (iconOnly) {
		return (
			<a
				className={className}
				data-tip={tooltipContent}
				href={url}
				target="_blank"
			>
				<span>
					<Icon
						className="bounce-circle"
						name="far fa-paintbrush-pencil"
					/>
				</span>
			</a>
		);
	} else {
		return (
			<BasicAction
				// When it's in a submenu, we use fas
				iconName = "fas fa-paintbrush-pencil"
				name = "Open in Imposium"
				handleClick = {() => {
					window.open(url, "_blank");
				}}
				isDisabled={isDisabled}
			/>
		);
	}
}
